import { render, staticRenderFns } from "./ServicesTypeInfo.vue?vue&type=template&id=6ac9485f&scoped=true&"
import script from "./ServicesTypeInfo.vue?vue&type=script&lang=js&"
export * from "./ServicesTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac9485f",
  null
  
)

export default component.exports